<template>
	<div>
		<span class="go-index" @click="pageTo()">返回</span>

		<br>
		<br>
		<br>
		<br>
		<br>
		<div class="address-div">

			<div class="address-list">
				<span>收件人*</span>
				<input type="text" placeholder="收件人" v-model="dizhiInfo.name" />
			</div>
			<div class="address-list">
				<span>手机号*</span>
				<input type="text" placeholder="手机号" v-model="dizhiInfo.phone" />
			</div>
			<div class="address-list">
				<span>所在地区* </span>
				<input type="text" placeholder="所在地区" v-model="dizhiInfo.area" />
			</div>

			<div class="address-list">
				<span>详细地址* </span>
				<input type="text" placeholder="详细地址" v-model="dizhiInfo.dizhi" />
			</div>

		</div>
		
		<span  @click="submit" style="display: block;width: 12rem;height: 0.8rem; font-size: 0.8rem; margin: 2rem auto;padding: 0.5rem 2rem; border: 1px solid grey;text-align: center; border-radius: 2rem;">保存</span>

		<!-- 组件使用 -->
		<!-- <foot /> -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.address-div {
		width: 80%;
		margin: 0.5rem auto;
		font-size: 0.5rem;
	}
	.address-list {
		margin: 0.5rem auto;
	}
	.address-div span
	{
		display: inline-block;
		width: 4rem;
	}
	.address-div input
	{
		box-shadow: rgb(204, 204, 204) 0px 0px 0.1rem;
		font-size: 0.5rem;
		/* border-bottom:1px solid grey ; */
	}
</style>
<script>
	// 组件引入
	import sy from "@/sy";
	// import foot from '@/components/foot.vue';
	
	// 组件引入
	import syalert from '@/components/syalert.vue';

	export default {
		name: 'address1',
		components: {
			// foot,
			syalert,
		},
		data() {
			return {
				dizhiInfo: 
				{
					name: '',
					phone: '',
					area: '',
					dizhi: '',
				},
			}
		},
		methods: {
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			check: function()
			{
				// 实例重命名
				let $_this = this;
				sy.http.get(
				{
					url: this.$root.API + 'Address/Get',
					data: {
					},
					success: function(res)
					{
						if( res.state === '0' )
						{
							return $_this.$refs.syalert_id.syalert(res.msg);
						}
						
						//console.log(res.data);
						$_this.dizhiInfo = res.data;  
					}
				});
			},
			submit: function()
			{
				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Address/Set',
					data: {
						name: this.dizhiInfo.name,
						phone: this.dizhiInfo.phone,
						area: this.dizhiInfo.area,
						dizhi: this.dizhiInfo.dizhi,
					},
					success: function(res)
					{
						$_this.$refs.syalert_id.syalert(res.msg);
					}
				});
			},

		},
		created() {
			this.check();
		},
	}
</script>